module.exports = __webpack_public_path__ + "media/warmPlay.375ff4f9.wav";